import {
  RolodexEntryDataType,
  RolodexEntryJson,
  RolodexEntryType,
  RolodexLoadedEntryJson,
} from 'types'

export enum DetectionModelName {
  BASIC_THRESHOLD = 'BasicThreshold',
}

interface AbstractDetectionModel {
  is_enabled: boolean
  model_name: DetectionModelName
  model_parameters: object
}

export interface BasicThresholdDetectionModel extends AbstractDetectionModel {
  model_name: DetectionModelName.BASIC_THRESHOLD
  model_parameters: {
    lower_threshold?: number
    lower_lower_threshold?: number
    upper_threshold?: number
    upper_upper_threshold?: number
  }
  is_enabled: boolean
}

export type DetectionModel = BasicThresholdDetectionModel

export interface DetectionConfigurationData extends RolodexEntryDataType {
  name?: string
  target_sensor_entry_id?: string
  is_enabled: boolean
  detection_models: DetectionModel[]
  polling_frequency_minutes: number
  last_polled_at?: string
}

export interface DetectionConfigurationEntry extends RolodexEntryJson<
  RolodexEntryType.DETECTION_CONFIGURATION,
  DetectionConfigurationData
> {
  type: RolodexEntryType.DETECTION_CONFIGURATION
  data: DetectionConfigurationData
}

export interface DetectionConfigurationLoadedEntry extends RolodexLoadedEntryJson {
  entry: DetectionConfigurationEntry
}
